// app/components/employerModalContent.jsx
import { useRef, useEffect } from 'react'
import { Form, useActionData, useNavigation } from '@remix-run/react'
import SocialIcons from '../components/socialIcons'

const EmployerModalContent = () => {
  const actionData = useActionData()
  const navigation = useNavigation()
  const formRef = useRef(null)

  useEffect(() => {
    if (actionData?.success) {
      formRef.current.reset()
    }
  }, [actionData])

  return (
    <div className="flex flex-col lg:flex-row">
      <div className="w-full lg:w-1/2 p-4">
        <h2 className="text-headline lg:text-display-md font-bold lg:mb-6">WE ARE WAITING TO HEAR FROM YOU!</h2>
        <div className="hidden lg:flex space-x-4 mb-6">
          <SocialIcons iconColor="text-pointed" iconHover="" iconSize="" />
        </div>
      </div>
      <div className="w-full lg:w-1/2 p-4">
        <Form ref={formRef} method="post" className="space-y-4">
          <input
            type="text"
            name="name"
            placeholder="Your Full Name"
            className="w-full px-4 py-2 border rounded-lg"
            required
          />
          <input
            type="text"
            name="companyName"
            placeholder="Company Name"
            className="w-full px-4 py-2 border rounded-lg"
            required
          />
          <input
            type="email"
            name="email"
            placeholder="Your Email"
            className="w-full px-4 py-2 border rounded-lg"
            required
          />
          <input type="type" name="type" defaultValue="employer" hidden />
          <textarea
            name="message"
            placeholder="Message to TalentLift"
            className="w-full px-4 py-2 border rounded-lg"
            rows="4"
            required
          ></textarea>
          <div className="flex justify-end">
            <button
              type="submit"
              className="w-1/2 py-3 bg-gradient-to-r from-gradient2 to-gradient2_80 hover:from-gradient2_80 hover:to-gradient2_80 text-white rounded-full"
              disabled={navigation.state === 'submitting'}
            >
              {navigation.state === 'submitting' ? 'Sending...' : 'SEND'}
            </button>
          </div>
        </Form>
        {actionData && (
          <div className={`flex justify-end mt-4 ${actionData.success ? 'text-primary' : 'text-error'}`}>
            {actionData.success ? 'Email sent successfully!' : `Failed to send email: ${actionData.error}`}
          </div>
        )}
      </div>
    </div>
  )
}

export default EmployerModalContent
